import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { initTheme } from "./lib/settings";
import { applyPalette } from "./lib/theme";
import "./lib/validation";
import "./styles.css";

// Inject the brand scales before React renders so first paint has the right colors.
applyPalette();
initTheme();

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found in index.html");
ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
